import Configuration from './Configuration';
export default class Configurations{
	constructor(entries){
		this._entries = entries;
	}
	get entries(){
		return this._entries;
	}
	static fromJSON(jArray, defaultConfiguration){
		const entries = [defaultConfiguration].concat(jArray.map(jObjectConfiguration=>Configuration.fromJSON(jObjectConfiguration)));
		return new Configurations(entries);
	}
}